import { render, staticRenderFns } from "./giftcardstocks.vue?vue&type=template&id=5398cfe5&"
import script from "./giftcardstocks.vue?vue&type=script&lang=js&"
export * from "./giftcardstocks.vue?vue&type=script&lang=js&"
import style0 from "./giftcardstocks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports